import {REST_METHODS} from '@/src/app/constants/api';
import {getAuthorizationToken} from '@/src/app/utils/authorizationToken';
import authorizedFetch from '@/src/app/utils/authorizedFetch';
import unauthorizedFetch from '@/src/app/utils/unauthorizedFetch';

const getCourseDetails = (slug, serverContext) => {
  const param = [
    {
      name: 'slug',
      value: slug,
    },
  ];

  const requestMethod = getAuthorizationToken(serverContext)
    ? authorizedFetch
    : unauthorizedFetch;

  // @ts-ignore
  return requestMethod({
    method: REST_METHODS.GET,
    path: `/api/v1/courses/search/course_by_slug`,
    queryParams: param,
    serverContext: serverContext,
  });
};

export default getCourseDetails;
